import type {
  ProductAndServiceTemplateFormSchema,
  ProductAndServiceTemplateMutationSchema,
} from '../schemas/products-and-services-template';

export function productAndServiceTemplateFormToUpdate({
  ...rest
}: ProductAndServiceTemplateFormSchema): ProductAndServiceTemplateMutationSchema {
  return {
    ...rest,
  };
}
